<div>
  <div
    class="container mt-[35px] mb-8 mx-auto "
  >
    <div class="footer-more-links-row">
      @for (slot of allSlotsData(); let i = $index; track i) {
        @if (slot?.slotType == 'WIDGET') {
          @switch (slot?.widget?.type) {
            @case ('FOOTER_DATA') {
              <p class="text-[16px] uppercase font-semibold mt-[15px] mb-[5px] pl-[10px] md:pl-[0px]">
                {{ slot?.widget?.data?.title }}
              </p>
              <ul class="list-none pl-[10px] md:pl-[0px]">
                @for (title of slot?.widget?.data?.data; track title) {
                  <li
                    class="text-[14px] inline-block mr-[5px] mb-[5px] after:content-['|'] after:mx-[5px] after:text-[#474747] last:after:hidden"
                  >
                    <a
                      class="text-[#474747] hover:text-[#F94D00] font-normal no-underline"
                      href="{{ title.url }}"
                      title="{{ title?.name }}"
                      >{{ title?.name }}</a
                    >
                  </li>
                }
              </ul>
            }
          }
        }
      }
    </div>
  </div>
  <div class="footer-points-row bg-[#162F4D] py-[20px] text-[#ffffff]">
    <div class="container mx-auto pl-[10px] md:pl-[0px] pr-[10px] md:pr-[0px]">
      <div class="flex flex-wrap items-center">
        <!-- left -->
        <div class="md:w-9/12 w-12/12 md:pb-0 pb-[50px]">
          <div class="flex flex-col gap-[15px]">
            <!-- re -->
            @for (slot of allSlotsData(); track slot; let i = $index) {
              @if (slot?.slotType == 'WIDGET') {
                @switch (slot?.widget?.type) {
                  @case ('HELPLINE_WIDGET') {
                    <div class="grid md:grid-cols-3 grid-cols-1 gap-[15px]">
                      @for (slot of slot?.widget?.data; track slot) {
                        <div class="flex gap-[10px]">
                          <div class="flex-shrink">
                            <img
                              [ngSrc]="slot?.img"
                              [width]="slot?.widgetAttributes?.width"
                              [height]="slot?.widgetAttributes?.height"
                              alt="{{ slot?.alt }}"
                              title="{{ slot?.alt }}"
                            />
                          </div>
                          <div class="text grow">
                            <strong class="text-[16px] font-bold">{{
                              slot?.title
                            }}</strong>
                            <span class="block text-[14px]">{{
                              slot?.subTitle
                            }}</span>
                            <small *ngIf="slot?.bottomTitle" class="d-block">{{
                              slot?.bottomTitle
                            }}</small>
                          </div>
                        </div>
                      }
                    </div>
                  }
                }
              }
            }
            <!-- re / -->
          </div>
        </div>
        <!-- left / -->
        <!-- right -->
        @for (slot of allSlotsData(); track slot; let i = $index) {
          @if (slot?.slotType == 'WIDGET') {
            @switch (slot?.widget?.type) {
              @case ('APP_WIDGET') {
                <div
                  class="md:pt-0 pt-[50px] md:w-3/12 w-12/12 text-center"
                  style="border-color: #ffffff"
                >
                  <strong class="text-[16px] font-bold block mb-[10px]">{{
                    slot?.widget?.data?.title
                  }}</strong>
                  <div class="flex gap-[10px] justify-center mb-[20px]">
                    @for (img of slot?.widget?.data?.appImg; track img) {
                      <a
                        target="_self"
                        href="{{ img?.url }}"
                        title="{{ img?.alt }}"
                        ><img
                          [ngSrc]="img?.img"
                          [width]="img?.widgetAttributes?.width"
                          [height]="img?.widgetAttributes?.height"
                          alt="{{ img?.alt }}"
                          title="{{ img?.alt }}"
                      /></a>
                    }
                  </div>
                  <strong class="text-[16px] font-bold block mb-[15px]">{{
                    slot?.widget?.data?.subTitle
                  }}</strong>
                  <div class="flex justify-center gap-[5px]">
                    @for (
                      img of slot?.widget?.data?.socialMediaImg;
                      track img
                    ) {
                      <a
                        class="w-[40px] h-[40px] justify-center items-center"
                        target="_self"
                        href="{{ img?.url }}"
                        title="{{ img?.alt }}"
                        ><img
                          [ngSrc]="img?.img"
                          [width]="img?.widgetAttributes?.width"
                          [height]="img?.widgetAttributes?.height"
                          alt="{{ img?.alt }}"
                          title="{{ img?.alt }}"
                      /></a>
                    }
                  </div>
                </div>
              }
            }
          }
        }
        <!-- right / -->
      </div>
    </div>
  </div>
  <!-- re -->
  @for (slot of allSlotsData(); track slot; let i = $index) {
    @if (slot?.slotType == 'WIDGET') {
      @switch (slot?.widget?.type) {
        @case ('HELP_WIDGET') {
          <div class="footer-bottom-row bg-[#ECFFDC] py-[30px]">
            <div
              class="container mx-auto pl-[10px] md:pl-[0px] pr-[10px] md:pr-[0px]"
            >
              <div class="flex flex-col md:flex-row w-full gap-[20px]">
                <!-- left -->
                <div class="w-full md:w-2/10">
                  <div class="grid grid-cols-2 md:grid-cols-3 gap-[20px]">
                    @for (slot of slot?.widget?.data?.helpData; track slot) {
                      <div class="md:last:col-span-1 last:col-span-3">
                        <p
                          class="text-[16px] font-bold text-[#162F4D] mb-[10px] uppercase"
                        >
                          {{ slot?.title }}
                        </p>
                        <ul class="space-y-[5px] pl-[15px] !list-disc">
                          @for (point of slot?.footerPoints; track point) {
                            <li>
                              @if(footerPoint()?.includes(point?.point)){
                                <a
                                  rel="nofollow"
                                  target="_self"
                                  href="{{ point?.url }}"
                                  title="{{ point?.point }}"
                                  class="text-[14px] text-[#000000] hover:text-[#F94D00] no-underline"
                                  >{{ point?.point }}</a
                                >
                              }@else {
                                <a
                                  target="_self"
                                  href="{{ point?.url }}"
                                  title="{{ point?.point }}"
                                  class="text-[14px] text-[#000000] hover:text-[#F94D00] no-underline"
                                  >{{ point?.point }}</a
                                >
                              }
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                </div>
                <!-- subscribe  -->
                <div>
                  <div class="subscribe-row text-center bg-[#ffffff] p-[15px] rounded-md shadow-md">
                    <p class="font-bold text-[#5B5B5B] text-[18px] mb-[15px]">
                      {{
                        slot?.widget?.data?.newsletterData
                          ?.renderableComponents[1]?.title
                      }}
                    </p>
                    <div
                      class="flex items-center bg-[#F4F6F8] rounded-full gap-[10px] pl-[10px] pr-[6px] pt-[6px] pb-[6px]"
                    >
                      <img
                        [ngSrc]="
                          slot?.widget?.data?.newsletterData
                            ?.renderableComponents[1]?.value?.img
                        "
                        [width]="
                          slot?.widget?.data?.newsletterData
                            ?.renderableComponents[1]?.value?.widgetAttributes
                            ?.width
                        "
                        [height]="
                          slot?.widget?.data?.newsletterData
                            ?.renderableComponents[1]?.value?.widgetAttributes
                            ?.height
                        "
                        alt="{{
                          slot?.widget?.data?.newsletterData
                            ?.renderableComponents[1]?.value?.alt
                        }}"
                        title="{{
                          slot?.widget?.data?.newsletterData
                            ?.renderableComponents[1]?.value?.alt
                        }}"
                      />

                      <div class="grow relative">
                        <input
                          type="{{
                            slot?.widget?.data?.newsletterData
                              ?.renderableComponents[1]?.value?.type
                          }}"
                          placeholder="{{
                            slot?.widget?.data?.newsletterData
                              ?.renderableComponents[1]?.value?.placeholder
                          }}"
                          class="w-100 input-field text-[12px] md:text-[13px] border-[0px] p-[10px] w-full rounded-3xl h-[44px]"
                          [(ngModel)]="email"
                        />

                        <span *ngIf="emailSubscribed">{{ subscriptionMsg }}</span>
                        <button
                          class="transition-all mt-[0px] uppercase border !bg-[#272727] hover:!bg-[#FF0000] text-[#ffffff] text-[12px] md:text-[14px] rounded-full  p-[10px] top-[5px] absolute right-[4px]"
                          (click)="subscribeNewsLetter()"
                        >
                          {{
                            slot?.widget?.data?.newsletterData
                              ?.renderableComponents[0]?.value?.title
                          }}
                        </button>
                      </div>
                    </div>
                  
                    <p class="text-[13px] text-[#5B5B5B] mt-[10px]">
                      {{
                        slot?.widget?.data?.newsletterData
                          ?.renderableComponents[1]?.bottomTitle
                      }}
                    </p>
                  </div>
                </div>
                <!-- subscribe  -->
              </div>
            </div>
          </div>
        }
        @case ('TEXT') {
          <div
            class="footer-copy-row py-[20px] text-center pb-[40px] md:pb-[10px] bg-[#fff]"
          >
            <div
              class="container mx-auto pl-[10px] md:pl-[0px] pr-[10px] md:pr-[0px]"
            >
              <div
                class="flex md:flex-row flex-col flex-wrap md:justify-between gap-[10px] justify-center items-center"
              >
                <div class="text-[#5B5B5B] text-[13px]">
                  {{ slot?.widget?.data?.copyrightData }}
                </div>
                <div class="max-w-max">
                  <img
                    [ngSrc]="slot?.widget?.data?.img"
                    class="max-w-full"
                    [width]="slot?.widget?.data?.widgetAttributes?.width"
                    [height]="slot?.widget?.data?.widgetAttributes?.height"
                    alt="{{ slot?.widget?.data?.alt }}"
                    title="{{ slot?.widget?.data?.alt }}"
                  />
                </div>
              </div>
            </div>
          </div>
        }
      }
    }
  }
</div>
